import { IDIService } from "./../../IDIService";

export interface ILoggerService extends IDIService {
    get LogLevel(): LogLevel;
    set LogLevel(level: LogLevel);

    DisableLogsFrom(name: string): void;
    EnableLogsFrom(name: string): void;
    
    Warning(message: string): void;
    Warning(contextClassType: string, message: string): void;

    Error(message: string): void;
    Error(contextClassType: string, message: string): void;

    Info(message: string): void;
    Info(contextClassType: string, message: string): void;

    Debug(message: string): void;
    Debug(contextClassType: string, message: string): void;

    Log(message: string): void;
    Log(contextClassType: string, message: string): void;
}

export enum LogLevel {
    Debug = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    None = 4,
}